module.exports = __webpack_public_path__ + "static/media/hero-osteo.ab51a112.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hero-osteo.jpg
// module id = 261
// module chunks = 0